module.exports = __webpack_public_path__ + "static/media/destaque-linhas-maquiagem.a14216fc.jpg";